import React, { useRef, useEffect } from 'react';
import CBEventTimeline from '@cb/apricot/CBEventTimeline';
import '@cb/apricot/CBButton';
import cn from 'classnames';
export const layout = ['horizontal', 'vertical'];
export const EventTimeline = ({ layout: controlLayout, ariaLabel, children }) => {
    const eventRef = useRef(null);
    useEffect(() => {
        const eventTimeline = CBEventTimeline({
            elem: eventRef.current,
        });
        return () => {
            if (eventTimeline) {
                eventTimeline.destroy();
            }
        };
    }, []);
    return (React.createElement("div", { className: cn('cb-event-timeline', `cb-event-cards-${controlLayout}`), role: "region", "aria-label": ariaLabel, "data-cbtrack-comp": "apricot-react:event-timeline", ref: eventRef },
        React.createElement("ol", { className: "cb-gutterh-24" }, children)));
};
//# sourceMappingURL=EventTimeline.js.map